// src/mocks/handlers/auth/otpHandler.ts
import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { genericResponse } from '@/shared/types/api';

export const otpHandler = rest.post<undefined, genericResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_OTP}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(400), ctx.json({ detail: 'Something went wrong' }));
    }

    return res(
      ctx.status(200),
      ctx.json({ message: 'OTP code successfully sent' }),
    );
  },
);
